import { useEffect } from 'react'

let activeListener: ((e: KeyboardEvent) => void) | null = null

export function useEscapeKeyListener(onEscape: () => void, isTopmost: boolean) {
  useEffect(() => {
    if (isTopmost) {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
          onEscape()
        }
      }

      // Remove any existing listener before adding new one
      if (activeListener) {
        document.removeEventListener('keydown', activeListener, true)
      }

      // Set new active listener
      activeListener = handleKeyDown
      document.addEventListener('keydown', handleKeyDown, true)

      return () => {
        document.removeEventListener('keydown', handleKeyDown, true)
        if (activeListener === handleKeyDown) {
          activeListener = null
        }
      }
    }
  }, [onEscape, isTopmost])
}